import css from './TaskModalCommentsAddCommentPlaceholder.module.css'

interface TaskModalCommentsAddCommentPlaceholderProps {
    onClick: () => void
}

const TaskModalCommentsAddCommentPlaceholder = ({ onClick }: TaskModalCommentsAddCommentPlaceholderProps) => {
    return (
        <div className={css.placeholder} onClick={onClick} data-testid="comment-add-placeholder">
            Leave a comment...
        </div>
    )
}

export default TaskModalCommentsAddCommentPlaceholder
